const TitleCell = ({ text, className }) => {
  return (
    <div
      className={`font-chinese py-2 px-1 whitespace-nowrap text-custom-gray bg-custom-yellow text-center ${className}`}
    >
      {text}
    </div>
  );
};

export default TitleCell;
